
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $a54aeb5a31979457$exports = {};
$a54aeb5a31979457$exports = JSON.parse("[{\"id\":\"pTIH01xTfus\",\"title\":\"How to Use Teacher Mode in Robogebra\",\"tags\":[\"How to use\",\"Teacher Mode\"]},{\"id\":\"d76LhwW7M-8\",\"title\":\"Analytics in Robogebra\",\"tags\":[\"How to use\",\"Analytics\"]},{\"id\":\"3y4EC_QJxe0\",\"title\":\"Solution View in Robogebra\",\"tags\":[\"How to use\",\"Solutions\"]},{\"id\":\"_RTK14kwrYw\",\"title\":\"How Teachers Can Create Their Own Solutions in Robogebra\",\"tags\":[\"How to use\",\"Solutions\"]},{\"id\":\"7MQtM5W7oXE\",\"title\":\"How to Use Interactive Worksheets for Teaching in Robogebra\",\"tags\":[\"How to use\",\"Worksheets\"]},{\"id\":\"Wn2tM7h6AcA\",\"title\":\"How Teachers Can Lock and Unlock Solutions in Robogebra\",\"tags\":[\"How to use\",\"Solutions\"]},{\"id\":\"Msl3QZr0JV8\",\"title\":\"How to Use Edit and Explore Feature in Robogebra\",\"tags\":[\"How to use\",\"Edit & Explore\"]}]");


/**
 * Help / tutorials page.
 *
 * Mirrors the in-app help screen (/help in the web app): a paged grid of "How to use" videos with
 * a playlist call to action. The app reads its list from study-materials/search, which is behind a
 * login - this site has no auth, so the same list lives in data/help-videos.json and the
 * thumbnails come straight from YouTube. Adding a tutorial means adding one entry to that file.
 */ // Six per page, the page size the in-app screen uses.
const $f126ac0782c36827$var$PAGE_SIZE = 6;
let $f126ac0782c36827$var$currentPage = 1;
let $f126ac0782c36827$var$totalPages = 1;
// The element that opened the lightbox, so focus goes back where it came from on close.
let $f126ac0782c36827$var$lastFocusedCard = null;
document.addEventListener('DOMContentLoaded', ()=>{
    const grid = document.getElementById('helpVideos');
    if (!grid) return;
    const videos = Array.isArray((0, (/*@__PURE__*/$parcel$interopDefault($a54aeb5a31979457$exports)))) ? (0, (/*@__PURE__*/$parcel$interopDefault($a54aeb5a31979457$exports))) : [];
    $f126ac0782c36827$var$totalPages = Math.max(1, Math.ceil(videos.length / $f126ac0782c36827$var$PAGE_SIZE));
    if (!videos.length) {
        $f126ac0782c36827$var$toggle(document.getElementById('helpEmptyState'), true);
        return;
    }
    $f126ac0782c36827$var$renderPage(videos, 1);
    $f126ac0782c36827$var$setupPagination(videos);
    $f126ac0782c36827$var$setupLightbox();
});
/** The slice of videos on screen, plus the pagination state that goes with it. */ function $f126ac0782c36827$var$renderPage(videos, page) {
    const grid = document.getElementById('helpVideos');
    $f126ac0782c36827$var$currentPage = Math.min(Math.max(page, 1), $f126ac0782c36827$var$totalPages);
    const start = ($f126ac0782c36827$var$currentPage - 1) * $f126ac0782c36827$var$PAGE_SIZE;
    const pageVideos = videos.slice(start, start + $f126ac0782c36827$var$PAGE_SIZE);
    grid.innerHTML = pageVideos.map($f126ac0782c36827$var$cardMarkup).join('');
    grid.querySelectorAll('.help-video-card').forEach((card)=>{
        card.addEventListener('click', ()=>$f126ac0782c36827$var$openLightbox(card));
    });
    $f126ac0782c36827$var$renderPagination();
}
function $f126ac0782c36827$var$cardMarkup(video) {
    const tags = (video.tags || []).map((tag)=>`<span class="help-tag">${$f126ac0782c36827$var$escapeHtml(tag)}</span>`).join('');
    return `
        <button type="button" class="help-video-card"
                data-video-id="${$f126ac0782c36827$var$escapeHtml(video.id)}"
                data-video-title="${$f126ac0782c36827$var$escapeHtml(video.title)}">
            <span class="help-thumbnail-wrapper">
                <img class="help-thumbnail"
                     src="https://i.ytimg.com/vi/${encodeURIComponent(video.id)}/hqdefault.jpg"
                     alt="${$f126ac0782c36827$var$escapeHtml(video.title)}"
                     loading="lazy">
                <span class="help-play-badge" aria-hidden="true">
                    <i class="fas fa-play"></i>
                </span>
            </span>
            <span class="help-video-info">
                <span class="help-title-wrapper">
                    <span class="help-video-title">${$f126ac0782c36827$var$escapeHtml(video.title)}</span>
                    <span class="help-video-icon" aria-hidden="true"><i class="fas fa-film"></i></span>
                </span>
                ${tags ? `<span class="help-video-tags">${tags}</span>` : ''}
            </span>
        </button>
    `;
}
function $f126ac0782c36827$var$setupPagination(videos) {
    const pagination = document.getElementById('helpPagination');
    if ($f126ac0782c36827$var$totalPages <= 1) {
        // A single page has nothing to page through.
        $f126ac0782c36827$var$toggle(pagination, false);
        return;
    }
    $f126ac0782c36827$var$toggle(pagination, true);
    document.getElementById('helpPrev').addEventListener('click', ()=>{
        if ($f126ac0782c36827$var$currentPage > 1) $f126ac0782c36827$var$goToPage(videos, $f126ac0782c36827$var$currentPage - 1);
    });
    document.getElementById('helpNext').addEventListener('click', ()=>{
        if ($f126ac0782c36827$var$currentPage < $f126ac0782c36827$var$totalPages) $f126ac0782c36827$var$goToPage(videos, $f126ac0782c36827$var$currentPage + 1);
    });
    document.getElementById('helpPageNumbers').addEventListener('click', (event)=>{
        const button = event.target.closest('[data-page]');
        if (button) $f126ac0782c36827$var$goToPage(videos, Number(button.dataset.page));
    });
}
/** Paging keeps the grid in view: without this the reader is left below the new first row. */ function $f126ac0782c36827$var$goToPage(videos, page) {
    $f126ac0782c36827$var$renderPage(videos, page);
    document.getElementById('helpVideos').scrollIntoView({
        behavior: 'smooth',
        block: 'start'
    });
}
function $f126ac0782c36827$var$renderPagination() {
    const numbers = document.getElementById('helpPageNumbers');
    if (!numbers) return;
    let markup = '';
    for(let page = 1; page <= $f126ac0782c36827$var$totalPages; page++){
        const active = page === $f126ac0782c36827$var$currentPage ? ' active' : '';
        const current = page === $f126ac0782c36827$var$currentPage ? ' aria-current="page"' : '';
        markup += `<button type="button" class="help-page-number${active}" data-page="${page}"${current}>${page}</button>`;
    }
    numbers.innerHTML = markup;
    document.getElementById('helpPrev').disabled = $f126ac0782c36827$var$currentPage === 1;
    document.getElementById('helpNext').disabled = $f126ac0782c36827$var$currentPage === $f126ac0782c36827$var$totalPages;
}
function $f126ac0782c36827$var$setupLightbox() {
    const lightbox = document.getElementById('helpLightbox');
    if (!lightbox) return;
    document.getElementById('helpLightboxClose').addEventListener('click', $f126ac0782c36827$var$closeLightbox);
    lightbox.querySelectorAll('[data-help-close]').forEach((element)=>{
        element.addEventListener('click', $f126ac0782c36827$var$closeLightbox);
    });
    // Escape closes it, as it does for the in-app modals.
    document.addEventListener('keydown', (event)=>{
        if (event.key === 'Escape' && !lightbox.hidden) $f126ac0782c36827$var$closeLightbox();
    });
}
function $f126ac0782c36827$var$openLightbox(card) {
    const lightbox = document.getElementById('helpLightbox');
    const videoId = card.dataset.videoId;
    const title = card.dataset.videoTitle;
    $f126ac0782c36827$var$lastFocusedCard = card;
    document.getElementById('helpLightboxTitle').textContent = title;
    // Set on open rather than at render time, so seven players are not loaded behind the grid.
    //
    // playsinline is what keeps the video in this dialog on iOS. Without it Safari hands the
    // stream to its own fullscreen player, which leaves the lightbox controls behind and is why
    // pause and fullscreen appeared to do nothing on a phone.
    document.getElementById('helpLightboxFrame').src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}` + '?autoplay=1&playsinline=1&rel=0';
    $f126ac0782c36827$var$toggle(lightbox, true);
    document.body.classList.add('help-lightbox-open');
    document.getElementById('helpLightboxClose').focus();
}
function $f126ac0782c36827$var$closeLightbox() {
    const lightbox = document.getElementById('helpLightbox');
    // Pointing the frame away is what actually stops playback - hiding the dialog does not.
    // about:blank rather than an empty src, which some browsers resolve back to this page.
    document.getElementById('helpLightboxFrame').src = 'about:blank';
    $f126ac0782c36827$var$toggle(lightbox, false);
    document.body.classList.remove('help-lightbox-open');
    if ($f126ac0782c36827$var$lastFocusedCard) {
        $f126ac0782c36827$var$lastFocusedCard.focus();
        $f126ac0782c36827$var$lastFocusedCard = null;
    }
}
function $f126ac0782c36827$var$toggle(element, visible) {
    if (element) element.hidden = !visible;
}
/** Titles and tags are authored data, but they still land in markup - so they are escaped. */ function $f126ac0782c36827$var$escapeHtml(value) {
    return String(value === undefined || value === null ? '' : value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}


//# sourceMappingURL=help.5df84fd5.js.map
